<div class="header">
	@if (label && ((!showForm && !form?.get(control).value) || !showEdit)) {
		<ic-label> {{ label }} </ic-label>
	}

	@if (!showEdit && editTemplate && form.get(control).enabled) {
		<ui-icon-button icon="fa fa-pencil" [help]="editText" (action)="edit()" />
	}
</div>

@if (!showEdit) {
	<p [class]="type"><ng-content /></p>
} @else {
	<div class="edit">
		@if (showForm) {
			<ng-template [ngTemplateOutlet]="editTemplate" />
			<div class="buttons">
				<ui-double-button icon="fa fa-times" type="secondary" (action)="cancelParagraph()">
					{{ cancelText }}
				</ui-double-button>
				<ui-double-button icon="fa fa-save" type="primary" [icValidateForms]="[form]" (confirm)="saveParagraph()">
					{{ saveText }}
				</ui-double-button>
			</div>
		} @else {
			<ui-text-button icon="fa fa-plus-circle" [disabled]="form.get(control).disabled" (action)="activateForm()">
				{{ activateText }}
			</ui-text-button>
		}
	</div>
}
